<template>
<div id="category">
  <div class="sectionIntro">
    <div class="sectionBack">
    </div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <router-link class="breadcrumb-item" to="/avatamsaka/chooseCategory">
          {{$t('avatamsaka.category.title')}}
        </router-link>
        <li class="breadcrumb-item active" aria-current="page">
            {{$t('avatamsaka.category.verIntro', {
              'noticeType': $t(`avatamsaka.category.verCategoryType[${versionId-1}].text`)
            })}}
        </li>
      </ol>
    </nav>

    <div class="introContent">
      <h2>
          {{$t('avatamsaka.category.verIntro', {
            'noticeType': $t(`avatamsaka.category.verCategoryType[${versionId-1}].text`)
          })}}
      </h2>
      <div class="treeContent" v-if="sutraList.length">

        <div class="sutraArea" v-for="(item, index) in treeData.children" :key="index">
          <div class="img">
            <img :src="sutraList[index].sutraImg" slot="aside" alt="" />
          </div>
          <ul class="detailTree">
            <TreeView class="item" :model="treeData.children[index]"
            :nowVer="versionId" :nowSutra="index+1">
            </TreeView>
          </ul>

        </div>

      </div>

    </div>
    <div class="introCover">
      <img src="@/../static/image/content/categoryIntro.png" />
    </div>
  </div>

</div>
</template>

<script>
import TreeView from './TreeView/TreeView';

export default {
  name: 'category',
  data() {
    return {
      nowVer: '2',
      treeData: 'AA3',
    };
  },
  components: {
    TreeView,
  },
  computed: {
    sutraList() {
      return this.$store.state.sutraList;
    },
    versionId() {
      return this.$route.params.vid;
    },
    versionList() {
      return this.$store.state.versionList;
    },
    filteredVersionList() {
      let versionList = [...this.versionList];
      const nowVersionId = Number(this.versionId);

      if (nowVersionId !== '') {
        versionList = versionList.filter(item => item.id === nowVersionId);
      }

      return versionList;
    },
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    fetchData() {
      const self = this;
      const myRequest = new Request(`/static/categories/categoryV${this.versionId}.json`);

      fetch(myRequest)
        .then(response => response.json())
        .then((data) => {
          self.treeData = data[0];
        });
    },
  },
  mounted() {
    this.$store.dispatch('getSutraList');
    this.$store.dispatch('getVersionList');
  },
};
</script>

<style lang="scss" scoped>
#category {

    .breadcrumb {
        margin: 0;
        background: #d9e2c4;
        position: absolute;
        top: 0;
        left: 0;
    }

    .sectionIntro {
        display: flex;
        padding-bottom: 50px;
        position: relative;

        .sectionBack {
            margin-bottom: 40px;
            width: 100%;
            height: 60%;
            background: #d9e2c4;
            position: absolute;

        }

        .sectionBack::after {

            border-top: 20vh solid #d9e2c4;
            border-right: 50vw solid transparent;
            border-left: 50vw solid transparent;
            content: "";
            top: 100%;
            left: 0;
            position: absolute;

        }

        .introCover {
            position: sticky;
            flex: 1.4;
            padding: 0;
            margin: 0;
            img {
                max-width: 500px;
                width: 100%;
                float: right;
            }
        }
        .introContent {

            > h2 {
                margin-top: 1.3em;
            }

            p {
                padding: 20px 20px 20px 0;
            }
            position: sticky;
            flex: 2;
            margin: 60px 60px 40px 40px;
            padding: 20px;
            text-align: left;
            align-self: center;
        }

    }

    .treeContent {

        margin-top: 2em;
        .sutraArea {

            padding-top: 2em;
            .img {
                width: 200px;
                height: auto;
                clear: both;
                float: left;

                img {
                    padding-top: 1em;
                    width: 100%;
                }
            }
            .detailTree {
                float: left;
                width: calc(90% - 200px);
                font-size: 1.3em;
            }
            ul {
                list-style: none;
            }
        }
    }

    @media (max-width: 1024px) {

        h2 {
            text-align: center;
        }

        button {
            display: block;
            margin: 20px auto;
        }

        .sectionIntro {

            .introCover {
                position: absolute;
                right: 0;
                padding: 0;
                margin: 0;
                img {
                    max-width: 500px;
                    width: 100%;
                    float: right;
                }
            }
            .introContent {

                > h2 {
                  margin-top: 2.3em;
                }

                p {
                    font-size: 0.8em;
                    margin: 0;
                    padding: 0 20px;

                    overflow: scroll;
                    position: relative;
                    line-height: 1.2em;
                    max-height: 15.6em;
                    text-align: center;
                    margin-right: -0.9em;
                    padding-right: 0.9em;
                }

                position: sticky;
                flex: 2;
                padding: 0;
                z-index: 1;
                background: rgba(255, 255, 255, 0.55);
                margin: 20px;
                text-align: left;
                align-self: center;
            }

        }

    }

  @media (max-width: 768px) {
    h2 {
      padding-top: 1.2em;
      font-size: 1.2em;
      font-weight: bold;
    }
    .breadcrumb {
      background: transparent;
      z-index: 2;
      font-size: 0.6em;
      padding: 2em;
    }

    .treeContent {
      margin-top: 0px;
      .sutraArea {
        width: 100%;
        .img {
          display: none;
          width: 0px;
        }
        ul {
          width: 100%;
          min-width: 100%;
          li {
            font-size: 0.8em;
          }
        }
      }
    }

  }

}
</style>



// WEBPACK FOOTER //
// src/components/Category.vue